module.exports = __webpack_public_path__ + "img/jdp.38a31952.svg";